import React from "react";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import downloadTokens from "@amzn/meridian-tokens/base/icon/download-large";
import { GetShiftPlanOutputResponse } from "../../../reviewAndPublish/model";
import { downloadPlanCsv, PlanExportMetadata } from "./downloadPlanCsv";
import { logCounterMetric, RCC_SHIFT_PLAN_GENERATION_PAGE, DOWNLOAD_SHIFT_PLAN_CSV } from "../../../../utils/metric-utils";

/**
 * "Download Plan" action (UTR-REFLEX-1163) — exports the selected plan as a CSV,
 * generated client-side from the shiftPlanOutput data. Disabled until a plan's
 * output is available. Meridian components only.
 */
interface DownloadPlanButtonProps {
  shiftPlanOutput?: GetShiftPlanOutputResponse;
  metadata: PlanExportMetadata;
}

const DownloadPlanButton: React.FC<DownloadPlanButtonProps> = ({ shiftPlanOutput, metadata }) => {
  const handleDownload = () => {
    if (!shiftPlanOutput) {
      return;
    }
    downloadPlanCsv(shiftPlanOutput, metadata);
    // Emit a count metric for the download action via the shared metric publisher.
    logCounterMetric(metadata.stationCode, RCC_SHIFT_PLAN_GENERATION_PAGE, DOWNLOAD_SHIFT_PLAN_CSV);
  };

  return (
    <Button type="primary" size="medium" disabled={!shiftPlanOutput} onClick={handleDownload}>
      <Icon tokens={downloadTokens} />
      Download Plan
    </Button>
  );
};

export default DownloadPlanButton;
